import { useEffect, useRef } from 'react';

const MODAL_OPEN_CLASSNAME = 'palette-modal--open';

const preventContentShifting = (isOpen: boolean) => {
    const scrollBarWidth = window.innerWidth - document.body.clientWidth;
    document.body.style.paddingRight = isOpen && scrollBarWidth > 0 ? `${scrollBarWidth}px` : '0px';
};

const getScrollLockElements = () => ([document.body, document.documentElement]);

export default (isOpen: boolean) => {
    const scrollOffset = useRef(0);
    const scrollLockIndicationReference = useRef(false);

    const enableScrollLock = () => {
        const { scrollY } = window;

        document.body.style.top = `-${scrollY}px`;

        getScrollLockElements()
            .forEach((element) => { element.classList.add(MODAL_OPEN_CLASSNAME); });

        scrollOffset.current = scrollY;
        scrollLockIndicationReference.current = true;
    };

    const disableScrollLock = () => {
        if (scrollLockIndicationReference.current) {
            document.body.style.top = '';

            getScrollLockElements()
                .forEach((element) => { element.classList.remove(MODAL_OPEN_CLASSNAME); });

            window.scrollTo(0, scrollOffset.current);
            scrollLockIndicationReference.current = false;
        }
    };

    useEffect(() => {
        preventContentShifting(isOpen);

        if (isOpen) {
            enableScrollLock();
        } else {
            disableScrollLock();
        }

        return disableScrollLock;
    }, [isOpen]);
};
